<form [formGroup]="form" autocomplete="off" (submit)="search()">
  <mat-form-field appearance="outline" color="accent">
    <mat-label>Find serviceaftale</mat-label>
    <input matInput formControlName="searchQuery" />
    <button
      type="submit"
      matSuffix
      class="btn-icon"
      color="accent"
      [disabled]="form?.invalid"
      matTooltip="Søg"
    >
      <mat-icon svgIcon="search"></mat-icon>
    </button>
    <mat-hint
      >Indtast navn, anlægsadresse, by, telefon eller aftalenummer eller
      <span class="link" (click)="hentSeneste()">Hent seneste</span></mat-hint
    >
  </mat-form-field>
</form>
<div>
  <p *ngIf="!response"></p>
  <p *ngIf="response && response?.rowCount == 0">
    Vi fandt ingen aftale der matcher søgningen.
  </p>
  <p *ngIf="response && response?.rowCount > serviceaftaler.length">
    Der findes flere aftaler der matcher søgningen. Prøv at lave en mere
    specifik søgning.
  </p>

  <table
    mat-table
    matSort
    multiTemplateDataRows
    [dataSource]="serviceaftaler"
    *ngIf="serviceaftaler && serviceaftaler.length > 0"
    class="mat-elevation-z0"
  >
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let serviceaftale">
        {{ serviceaftale.produktId }}
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let serviceaftale">
        {{ serviceaftale.serviceaftaleStateText }}
      </td>
    </ng-container>
    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef>Partner</th>
      <td mat-cell *matCellDef="let serviceaftale">
        <button
          type="button"
          (click)="
            [
              $event.stopPropagation(),
              openPartnerInfo(serviceaftale.partnerInfo)
            ]
          "
          class="btn-icon blue"
        >
          {{ serviceaftale.partnerInfo.name }}
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="serviceabonnement">
      <th mat-header-cell *matHeaderCellDef>Serviceabonnement</th>
      <td mat-cell *matCellDef="let serviceaftale">
        {{ serviceaftale.serviceabonnement }}
      </td>
    </ng-container>
    <ng-container matColumnDef="aftaleNummer">
      <th mat-header-cell *matHeaderCellDef>Aftale nr.</th>
      <td mat-cell *matCellDef="let serviceaftale">
        {{ serviceaftale.okKundeAftaleNr }}
      </td>
    </ng-container>
    <ng-container matColumnDef="kundeNavn">
      <th mat-header-cell *matHeaderCellDef>Navn</th>
      <td mat-cell *matCellDef="let serviceaftale">
        {{ serviceaftale.navn }}
      </td>
    </ng-container>
    <ng-container matColumnDef="kundeAdresse">
      <th mat-header-cell *matHeaderCellDef>Anlægsadresse</th>
      <td mat-cell *matCellDef="let serviceaftale">
        {{ serviceaftale.adresse }}
      </td>
    </ng-container>
    <ng-container matColumnDef="rowAction">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let serviceaftale">
        <div class="flex">
          <a
            *ngIf="
              (serviceaftale.serviceaftaleStateId == 2 ||
                serviceaftale.serviceaftaleStateId == 3) &&
              serviceaftale.kreditvaerdig !== 3
            "
            class="btn btn--red btn-add-small btn-icon"
            [routerLink]="[
              '/ordre',
              serviceaftale.serviceAftaleNo,
              { okKundeAftaleNr: serviceaftale.okKundeAftaleNr }
            ]"
            title="Opret tilkald for {{ serviceaftale.okKundeAftaleNr }}"
          >
            <mat-icon svgIcon="add-small"></mat-icon>
            Opret tilkald
          </a>
          <span *ngIf="serviceaftale.kreditvaerdig === 3">
            Der er forhold på kunden som gør at det ikke er muligt at oprette
            tilkald, kontakt OK for nærmere besked.
          </span>
          <button
            type="button"
            class="btn-icon"
            matTooltip="Vis serviceordre"
            *ngIf="serviceaftale.serviceordrer.length > 0"
          >
            <mat-icon [class.hidden]="expandedElement === serviceaftale"
              >expand_more</mat-icon
            >
            <mat-icon [class.hidden]="expandedElement !== serviceaftale"
              >expand_less</mat-icon
            >
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let element"
        [attr.colspan]="displayedColumns.length"
      >
        <div class="row-details">
          <ng-container
            *ngIf="
              element === expandedElement &&
              expandedElement.serviceordrer.length > 0
            "
          >
            <table class="mat-table">
              <thead>
                <tr class="mat-header-row">
                  <th class="mat-header-cell">Deadline</th>
                  <th class="mat-header-cell">Ordrenr.</th>
                  <th class="mat-header-cell">Opgave</th>
                  <th class="mat-header-cell">Status</th>
                  <th class="mat-header-cell">Partner</th>
                  <th class="mat-header-cell">Ændret</th>
                  <th class="mat-header-cell">Oprettet</th>
                  <th class="mat-header-cell">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let serviceordre of expandedElement.serviceordrer"
                  class="mat-row"
                >
                  <td class="mat-cell">
                    {{ serviceordre.deadline | date: "dd.MM.yyyy" }}
                  </td>
                  <td class="mat-cell">{{ serviceordre.serviceordreNo }}</td>
                  <td class="mat-cell">
                    <div
                      class="flex-wrap flex-wrap--align-center flex-wrap--flex-start"
                    >
                      {{ serviceordre.opgaveText }}
                      <mat-icon
                        class="material-icons cursor-help"
                        svgIcon="note"
                        *ngIf="serviceordre.note"
                        [matTooltip]="serviceordre.note"
                      ></mat-icon>
                    </div>
                  </td>
                  <td class="mat-cell">
                    {{ serviceordre.serviceordreStateText }}
                  </td>
                  <td class="mat-cell">
                    <button
                      type="button"
                      (click)="
                        [
                          $event.stopPropagation(),
                          openPartnerInfo(serviceordre.partnerInfo)
                        ]
                      "
                      class="btn-icon blue"
                    >
                      {{ serviceordre.partnerInfo.name }}
                    </button>
                  </td>
                  <td class="mat-cell">
                    <div
                      class="flex-wrap flex-wrap--align-center flex-wrap--flex-start"
                    >
                      {{ serviceordre.ajourtid | date: "dd.MM.yyyy" }}
                      <mat-icon
                        class="material-icons cursor-help"
                        matTooltip="{{
                          serviceordre.ajourtid | date: 'dd.MM.yyyy HH:mm'
                        }} af {{ serviceordre.ajourinit }}"
                        svgIcon="avatar"
                      ></mat-icon>
                    </div>
                  </td>
                  <td class="mat-cell">
                    <div
                      class="flex-wrap flex-wrap--align-center flex-wrap--flex-start"
                    >
                      {{ serviceordre.oprettid | date: "dd.MM.yyyy" }}
                      <mat-icon
                        class="material-icons cursor-help"
                        matTooltip="{{
                          serviceordre.oprettid | date: 'dd.MM.yyyy HH:mm'
                        }} af {{ serviceordre.opretinit }}"
                        svgIcon="avatar"
                      ></mat-icon>
                    </div>
                  </td>

                  <td class="mat-cell">
                    <div
                      class="flex-wrap flex-wrap--align-center flex-wrap--flex-start"
                    >
                      <div
                        *ngIf="
                          serviceordre.opgaveText == 'Tilkald' &&
                          (serviceordre.serviceordreStateText ==
                            'Klar til overførsel' ||
                            serviceordre.serviceordreStateText == 'Overført' ||
                            serviceordre.serviceordreStateText ==
                              'Oprettet og Overført' ||
                            serviceordre.serviceordreStateText == 'Afvist')
                        "
                        (click)="
                          cancel(serviceordre.serviceordreNo, expandedElement)
                        "
                        class="btn btn--red btn-add-small btn-icon"
                      >
                        Annuller ordre
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [class.row-detail-wrap--expanded]="expandedElement === row"
      [class.cursor-pointer]="row.serviceordrer.length > 0"
      (click)="expandedElement = expandedElement === row ? null : row"
    ></tr>

    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="row-detail-wrap"
    ></tr>
  </table>
</div>
